import axiosClient from 'api/shared/AxiosClient';
class SettingService {

    // ################ > FAQs   < ############## 

    // >>>>  Category
    getCategoryList = async () => {
        const resp = await axiosClient.get(
            `/faqs`
        );

        if (resp.data) {
            return (resp.data);
        }

        else {
            throw new Error("Something went wrong!");
        }
    }

    deleteCategory = async (id) => {
        const resp = await axiosClient.delete(
            `/faqs/category/${id}`
        );

        if (resp.data) {
            return (resp.data);

        }
        else {
            throw new Error("Something went wrong!");
        }

    }

    updateCategory = async (id, data) => {
        const resp = await axiosClient.post(
            `/faqs/category/edit/${id}`,
            data
        );

        if (resp.data) {
            return (resp.data);

        }
        else {
            throw new Error("Something went wrong!");
        }

    }

    createCategory = async (data) => {
        const resp = await axiosClient.post(
            `/faqs/category/create`,
            data
        );

        if (resp.data) {
            return (resp.data);

        }

        else {
            throw new Error("Something went wrong!");
        }

    }

    // >>>> FAQ
    getFaqList = async (category_id) => {
        const resp = await axiosClient.get(
            `/faqs/category/${category_id}`
        );

        if (resp.data) {
            return (resp.data);

        }

        else {
            throw new Error("Something went wrong!");
        }
    }

    getFaq = async (id, id_category) => {
        const resp = await axiosClient.get(
            `/faqs/category/${id_category}/${id}`
        );

        if (resp.data) {
            return (resp.data);
        }

        else {
            throw new Error("Something went wrong!");
        }
    }

    createFaq = async (category_id, data) => {
        const resp = await axiosClient.post(
            `/faqs/category/add/${category_id}`, data
        );

        if (resp.data) {
            return (resp.data);

        }

        else {
            throw new Error("Something went wrong!");
        }
    }

    deleteFaq = async (id, id_category) => {
        const resp = await axiosClient.delete(
            `/faqs/category/${id_category}/${id}`
        );
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }
    }

    updateFaq = async (id, id_category, data) => {
        const resp = await axiosClient.post(
            `/faqs/category/edit/${id_category}/${id}`,
            data
        );
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }
    }


    // ################ >  Main Menu < ############## 

    getMenuList = async () => {
        const resp = await axiosClient.get(
            `/mainmenus`
        );
        if (resp.data) {
            return (resp.data);

        } else {
            throw new Error("Something went wrong!");
        }
    }

    getMenu = async (id) => {
        const resp = await axiosClient.get(
            `/mainmenus/${id}`
        );
        if (resp.data) {
            return (resp.data);

        } else {
            throw new Error("Something went wrong!");
        }
    }


    deleteMenu = async (id) => {
        const resp = await axiosClient.delete(
            `/mainmenus/${id}`
        );
        if (resp.data) {
            return (resp.data);

        } else {
            throw new Error("Something went wrong!");
        }

    }

    updateMenu = async (id, data) => {
        const resp = await axiosClient.post(
            `/mainmenus/${id}`,
            data
        );
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }

    }

    createMenu = async (data) => {
        const resp = await axiosClient.post(
            `/mainmenus/create`,
            data
        );
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }
    }

    // ################ > Announcements < ############## 

    getAnnouncementMsg = async () => {
        const resp = await axiosClient.get(
            `/announcements`
        );

        if (resp.data) {
            return (resp.data);
        }
        else {
            throw new Error("Something went wrong!");
        }
    }

    updateAnnouncementMsg = async (id, data) => {
        const resp = await axiosClient.post(
            `/announcements/${id}`, data
        );
        if (resp.data) {
            return (resp.data);
        }
        else {
            throw new Error("Something went wrong!");
        }

    }

    createAnnouncementMsg = async (data) => {
        const resp = await axiosClient.post(
            `/announcements`, data
        );
        if (resp.data) {
            return (resp.data);
        }
        else {
            throw new Error("Something went wrong!");
        }

    }


    deleteAnnouncementMsg = async (id) => {
        const resp = await axiosClient.delete(
            `/announcements/${id}`)
        if (resp.data) {
            return (resp.data);
        }
        else {
            throw new Error("Something went wrong!");
        }

    }

}

const settingService = new SettingService();
export default settingService;


